import { produce } from 'immer';

export const createMedicalReceiptSlice = (set) => ({
  serviceParams: {},
  addServiceParams: (newParams) =>
    set(
      produce(({ medicalReceipt }) => {
        medicalReceipt.serviceParams = newParams;
      }),
    ),
  parkingBarCodeData: '',
  setParkingBarCodeData: (newParams) =>
    set(
      produce(({ medicalReceipt }) => {
        medicalReceipt.parkingBarCodeData = newParams;
      }),
    ),
  payComplete: '',
  setPayComplete: (newParams) =>
    set(
      produce(({ medicalReceipt }) => {
        medicalReceipt.payComplete = newParams;
      }),
    ),
  receiptData: null,
  setReceiptData: (newParams) =>
    set(
      produce(({ medicalReceipt }) => {
        medicalReceipt.receiptData = newParams;
      }),
    ),
  detailReceiptStatus: null,
  setDetailReceiptStatus: (newParams) =>
    set(
      produce(({ medicalReceipt }) => {
        medicalReceipt.detailReceiptStatus = newParams;
      }),
    ),
});
